import {
  outreachBatchSchema,
  outreachDetailSchema,
  outreachOpenResultSchema,
  type OutreachBatch,
  type OutreachDetail,
  type OutreachOpenResult,
} from '@secretario/shared';
import { z } from 'zod';
import { apiFetch } from './http.js';

/**
 * Envios em lote (T7.41). O servidor é o dono do envio: a página, a cápsula e o cartão da mesa
 * só mostram e mandam os toques (pausar, abrir o próximo WhatsApp, "mandou?").
 */
export const OUTREACH_KEY = ['outreach'] as const;
export const outreachKey = (id: string) => ['outreach', id] as const;

const list = z.object({ batches: z.array(outreachBatchSchema) });

export async function listOutreach(): Promise<OutreachBatch[]> {
  return list.parse(await apiFetch<unknown>('/v1/outreach')).batches;
}
export async function getOutreach(id: string): Promise<OutreachDetail> {
  return outreachDetailSchema.parse(await apiFetch<unknown>(`/v1/outreach/${id}`));
}
export async function outreachAction(
  id: string,
  action: 'pause' | 'resume' | 'cancel',
): Promise<OutreachDetail> {
  return outreachDetailSchema.parse(
    await apiFetch<unknown>(`/v1/outreach/${id}/${action}`, { method: 'POST', body: {} }),
  );
}
export async function outreachItem(
  id: string,
  itemId: string,
  action: 'remove' | 'requeue',
): Promise<OutreachDetail> {
  return outreachDetailSchema.parse(
    await apiFetch<unknown>(`/v1/outreach/${id}/items/${itemId}/${action}`, {
      method: 'POST',
      body: {},
    }),
  );
}
export async function markOutreach(
  id: string,
  itemId: string,
  state: 'enviado' | 'pulado',
): Promise<OutreachDetail> {
  return outreachDetailSchema.parse(
    await apiFetch<unknown>(`/v1/outreach/${id}/items/${itemId}/mark`, {
      method: 'POST',
      body: { state },
    }),
  );
}
export async function openNextOutreach(
  id: string,
  previous?: 'enviado' | 'pulado',
): Promise<OutreachOpenResult> {
  return outreachOpenResultSchema.parse(
    await apiFetch<unknown>(`/v1/outreach/${id}/open-next`, {
      method: 'POST',
      body: previous ? { previous } : {},
    }),
  );
}
/** Os vales dos botões do aviso fixo do Android (abrir, não mandei, pausar, retomar). */
export async function outreachDeviceGrants(id: string): Promise<Record<string, string>> {
  return z
    .object({ grants: z.record(z.string(), z.string()) })
    .parse(
      await apiFetch<unknown>(`/v1/outreach/${id}/device-grants`, { method: 'POST', body: {} }),
    ).grants;
}
export async function leaveOutreach(id: string): Promise<string> {
  return z
    .object({ sender: z.string() })
    .parse(await apiFetch<unknown>(`/v1/outreach/${id}/leave`, { method: 'POST', body: {} }))
    .sender;
}
